import { morph } from '@theme/morph';
import { Component } from '@theme/component';
import { CartUpdateEvent, ThemeEvents } from '@theme/events';
import { DialogComponent, DialogCloseEvent } from '@theme/dialog';
import { mediaQueryLarge, isMobileBreakpoint, getIOSVersion } from '@theme/utilities';

const europeanCountries = [
  'AL',
  'AD',
  'AT',
  'BY',
  'BE',
  'BA',
  'BG',
  'HR',
  'CY',
  'CZ',
  'DK',
  'EE',
  'FO',
  'FI',
  'FR',
  'DE',
  'GI',
  'GR',
  'HU',
  'IS',
  'IE',
  'IM',
  'IT',
  'RS',
  'LV',
  'LI',
  'LT',
  'LU',
  'MK',
  'MT',
  'MD',
  'MC',
  'ME',
  'NL',
  'NO',
  'PL',
  'PT',
  'RO',
  'RU',
  'SM',
  'RS',
  'SK',
  'SI',
  'ES',
  'SE',
  'CH',
  'UA',
  'GB',
  'VA',
  'RS',
];

const africanCountries = [
  'DZ',
  'AO',
  'SH',
  'BJ',
  'BW',
  'BF',
  'BI',
  'CM',
  'CV',
  'CF',
  'TD',
  'KM',
  'CG',
  'CD',
  'DJ',
  'EG',
  'GQ',
  'ER',
  'SZ',
  'ET',
  'GA',
  'GM',
  'GH',
  'GN',
  'GW',
  'CI',
  'KE',
  'LS',
  'LR',
  'LY',
  'MG',
  'MW',
  'ML',
  'MR',
  'MU',
  'YT',
  'MA',
  'MZ',
  'NA',
  'NE',
  'NG',
  'ST',
  'RE',
  'RW',
  'ST',
  'SN',
  'SC',
  'SL',
  'SO',
  'ZA',
  'SS',
  'SH',
  'SD',
  'SZ',
  'TZ',
  'TG',
  'TN',
  'UG',
  'CD',
  'ZM',
  'TZ',
  'ZW',
];

const americanCountries = [
  'US',
  'CA',
  'MX',
  'AR',
  'BO',
  'BR',
  'CL',
  'CO',
  'EC',
  'FK',
  'GF',
  'GY',
  'PY',
  'PE',
  'SR',
  'UY',
  'VE',
  'AI',
  'AG',
  'AW',
  'BS',
  'BB',
  'BZ',
  'BM',
  'BQ',
  'VG',
  'KY',
  'CR',
  'CU',
  'CW',
  'DM',
  'DO',
  'SV',
  'GL',
  'GD',
  'GP',
  'GT',
  'HT',
  'HN',
  'JM',
  'MQ',
  'PM',
  'MS',
  'CW',
  'KN',
  'NI',
  'PA',
  'PR',
  'BQ',
  'SX',
  'KN',
  'LC',
  'PM',
  'VC',
  'TT',
  'TC',
  'VI',
];

// If set, this indicates that we've already prompted the user that they may want the other store,
// and the user has rejected it, opting to stay at the current store.
const storageKey = '1bitsquared_stay_here';

function gotoEuro() {
  window.location.href = 'https://1bitsquared.de' + window.location.pathname;
}

function stayHere() {
  // Store that the user wants to stay here in session storage.
  window.sessionStorage.setItem(storageKey, 'true');
}

class CountryDialog extends DialogComponent {
  #abortController = new AbortController();

  connectedCallback() {
    console.log('country dialog loaded')

    super.connectedCallback();

    this.addEventListener(DialogCloseEvent.eventName, this.#handleDialogClose);

    const dialog = this;

    if (window.location.hostname == "1bitsquared.com") {
      if (window.sessionStorage.getItem(storageKey) === null) {
        console.log('checking user location for redirect');

        fetch('https://cloudflare.com/cdn-cgi/trace')
          .then((response) => {
            return response.text();
          })
          .then((text) => {
            const data = text.trim().split('\n').reduce((obj, pair) => {
              pair = pair.split('=');
              return (obj[pair[0]] = pair[1]), obj;
            }, {});

            if (europeanCountries.includes(data.loc)) {
              console.log('european country detected, displaying dialog');

              dialog.showDialog();

              console.log('country dialog displayed');
            } else {
              console.log('skipping displaying country dialog');
            }
          });
      } else {
        console.log('skipping country dialog check');
      }
    }
  }

  disconnectedCallback() {
    super.disconnectedCallback();

    this.#abortController.abort();
    this.removeEventListener(DialogCloseEvent.eventName, this.#handleDialogClose);
  }

  #handleDialogClose = () => {
    const iosVersion = getIOSVersion();
    /**
     * This is a patch to solve an issue with the UI freezing when the dialog is closed.
     * To reproduce it, use iOS 16.0.
     */
    if (!iosVersion || iosVersion.major >= 17 || (iosVersion.major === 16 && iosVersion.minor >= 4)) return;

    requestAnimationFrame(() => {
      /** @type {HTMLElement | null} */
      const grid = document.querySelector('#ResultsList [product-grid-view]');
      if (grid) {
        const currentWidth = grid.getBoundingClientRect().width;
        grid.style.width = `${currentWidth - 1}px`;
        requestAnimationFrame(() => {
          grid.style.width = '';
        });
      }
    });
  };

  gotoEuro() {
    window.location.href = 'https://1bitsquared.de' + window.location.pathname;
  }

  stayHere() {
    const dialog = this;

    // Store that the user wants to stay here in session storage.
    window.sessionStorage.setItem(storageKey, 'true');

    dialog.closeDialog();
  }
}

if (!customElements.get('country-dialog')) {
  console.log('registering country dialog component')
  customElements.define('country-dialog', CountryDialog);
}
